import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {Divider} from '@/components/ui/divider/Divider'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {WarningLabel} from '@/components/ui/warning-label/WarningLabel'

interface SocialWelfareConditionsCardEmptyStateProps {
    isLoading: boolean
    isEvolutionaryAge?: boolean
}
export const SocialWelfareConditionsCardEmptyState = ({
    isLoading,
    isEvolutionaryAge
}: SocialWelfareConditionsCardEmptyStateProps) => {
    const {t} = useTranslation()

    return (
        <Grid columns={3} gap={3} fullWidth>
            {isEvolutionaryAge && (
                <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                    <DetailsField fullWidth>
                        <Text palette="neutral" shade="500" size="textSm">
                            {t('projects:parental_responsibility')}
                        </Text>
                        {isLoading ? <Skeleton height={24} /> : <WarningLabel text={t('users:to_compile')} />}
                    </DetailsField>
                    <Divider direction="horizontal" />
                </Flexbox>
            )}

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:applicant')}
                    </Text>
                    {isLoading ? <Skeleton height={24} /> : <WarningLabel text={t('users:to_compile')} />}
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:ssn_cost_percentage')}
                    </Text>
                    {isLoading ? <Skeleton height={24} /> : <WarningLabel text={t('users:to_compile')} />}
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:shared_care_planning')}
                    </Text>
                    {isLoading ? <Skeleton height={24} /> : <WarningLabel text={t('users:to_compile')} />}
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:social_rehabilitation_treatments')}
                    </Text>
                    {isLoading ? <Skeleton height={24} /> : <WarningLabel text={t('users:to_compile')} />}
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:formal_or_informal_networks_support')}
                    </Text>
                    {isLoading ? <Skeleton height={24} /> : <WarningLabel text={t('users:to_compile')} />}
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:caregiver')}
                    </Text>
                    {isLoading ? <Skeleton height={24} /> : <WarningLabel text={t('users:to_compile')} />}
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <DetailsField fullWidth>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('projects:daily_activities_autonomy_level')}
                </Text>
                {isLoading ? <Skeleton height={24} /> : <WarningLabel text={t('users:to_compile')} />}
            </DetailsField>

            <DetailsField fullWidth>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('projects:mobility_autonomy_level')}
                </Text>
                {isLoading ? <Skeleton height={24} /> : <WarningLabel text={t('users:to_compile')} />}
            </DetailsField>
        </Grid>
    )
}
